export class ScreenTransition {
  private root: HTMLDivElement;
  private isAnimating = false;

  constructor(private durationMs: number = 450) {
    this.root = document.createElement('div');
    this.root.style.position = 'fixed';
    this.root.style.inset = '0';
    this.root.style.background = '#000';
    this.root.style.opacity = '0';
    this.root.style.transition = `opacity ${this.durationMs}ms ease`;
    this.root.style.pointerEvents = 'none';
    this.root.style.zIndex = '10000';
    this.root.style.display = 'none';
    document.body.appendChild(this.root);
  }

  async fadeOutIn(action?: () => void | Promise<void>): Promise<void> {
    if (this.isAnimating) return;
    this.isAnimating = true;
    await this.fadeTo(1);
    if (action) {
      await action();
    }
    await this.fadeTo(0);
    this.isAnimating = false;
  }

  async fadeOutOnly(action?: () => void | Promise<void>): Promise<void> {
    if (this.isAnimating) return;
    this.isAnimating = true;
    await this.fadeTo(1);
    if (action) {
      await action();
    }
    // Keep overlay visible (black) for caller to manage (e.g., reload)
  }

  private fadeTo(targetOpacity: number): Promise<void> {
    return new Promise((resolve) => {
      if (targetOpacity > 0) {
        this.root.style.display = 'block';
        this.root.style.pointerEvents = 'auto';
      } else {
        this.root.style.pointerEvents = 'none';
      }

      requestAnimationFrame(() => {
        this.root.style.opacity = targetOpacity.toString();
      });

      const timeout = window.setTimeout(() => {
        if (targetOpacity === 0) {
          this.root.style.display = 'none';
        }
        window.clearTimeout(timeout);
        resolve();
      }, this.durationMs);
    });
  }
}

